module.exports = _.upperFirst;